<div class="container-fluid spacer-top-navigation">
  <div class="container">
    <div class="row row--primary tile" data-zid="deposit">
      <div class="row">
        <div class="col-12">
          <h5>{{ 'mydepot.deposit.headline' | transloco }}</h5>
          <web-design-system-divider />
        </div>
        <div class="col-12 mb-2">
          <p>
            {{ 'mydepot.deposit.header' | transloco }}
          </p>
        </div>
        <div class="col-12 col-sm-4">
          {{ 'mydepot.deposit.customer' | transloco }}
        </div>
        @if (currentCustomer) {
          <div class="col-12 col-sm-8 font-medium" data-zid="deposit-name">
            {{ currentCustomer.firstName }} {{ currentCustomer.lastName }}
          </div>
        }

        @if (customerStateFacade.customerAccountData$ | async; as customerAccount) {
          <div class="col-12 col-sm-4">
            {{ 'mydepot.deposit.iban' | transloco }}
          </div>
          <div class="col-12 col-sm-8 font-medium">
            <web-design-system-copy-to-clipboard
              data-zid="deposit-iban"
              [label]="customerAccount.accountIban | formateIban"
              iconCssClass="icon-dark"
              [hint]="'mydepot.deposit.copy-iban' | transloco"
            />
          </div>
        }

        <div class="col-12 col-sm-4">
          {{ 'mydepot.deposit.bic' | transloco }}
        </div>
        <div class="col-12 col-sm-8 font-medium">
          <web-design-system-copy-to-clipboard
            data-zid="deposit-bic"
            label="BDWBDEMMXXX"
            iconCssClass="icon-dark"
            [hint]="'mydepot.deposit.copy-bic' | transloco"
          />
        </div>
        <div class="col-12 col-sm-4">{{ 'mydepot.deposit.bank' | transloco }}</div>
        <div class="col-12 col-sm-8 font-medium mb-4" data-zid="deposit-bank">Baader Bank</div>
      </div>
      <div class="row">
        <div class="col-12 text-size-medium">{{ 'mydepot.deposit.hint' | transloco }}</div>
      </div>
    </div>

    <div class="row row--primary tile" data-zid="money-transaction">
      <depot-money-transaction [toggleTile]="false" />
    </div>
  </div>
</div>
